import {html, LitElement} from 'lit';
import styles from './x-loader.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/ui-utils';

export class Loader extends LitElement {
	static styles = [styles];

	static get properties () {
		return {
			aspectRatio: {
				attribute: 'aspect-ratio',
				type: String
			},
			aspectRatioDesktop: {
				attribute: 'aspect-ratio-desktop',
				type: String
			},
			aspectRatioTablet: {
				attribute: 'aspect-ratio-tablet',
				type: String
			},
			fill: {
				type: Boolean
			}
		};
	}

	constructor () {
		super();

		this.aspectRatio = '400/ 500';
		this.aspectRatioTablet = '740/ 497';
		this.aspectRatioDesktop = '1720/ 523';
		this.fill = false;
	}

	render () {
		return html`
			<style>
				:host {
					--aspect-ratio: ${this.fill ? 'auto' : this.aspectRatio};
					--aspect-ratio-tablet: ${this.fill ? 'auto' : this.aspectRatioTablet};
					--aspect-ratio-desktop: ${this.fill ? 'auto' : this.aspectRatioDesktop};
				}
			</style>

			<svg
				class="ring"
				viewBox="25 25 50 50"
				stroke-width="5"
			>
				<circle cx="50" cy="50" r="20" />
			</svg>
		`;
	}
};

defineCustomElement('x-loader', Loader);
